import React from 'react';
import PropTypes from 'prop-types';

const Numpad = ({ value, setValue }) => {
    const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];

    const onClick = event => {
        const target = event.target.closest('.numpad__button');

        if (!target) {
            return;
        }

        const data = target.dataset;

        if (typeof data.number === 'string') {
            value.push(data.number);
        }

        if (data.backspace) {
            value.pop();
        }

        setValue(value);
    };

    return (
        <div className="numpad">
            {numbers.map(number => (
                <button
                    className="numpad__button"
                    onClick={onClick}
                    disabled={value.length >= 4}
                    data-number={number}
                >
                    {number}
                </button>
            ))}
            <button
                className="numpad__button"
                onClick={onClick}
                disabled
            >
                {' '}
            </button>
            <button
                className="numpad__button"
                onClick={onClick}
                disabled={value.length >= 4}
                data-number={0}
            >
                {0}
            </button>
            <button
                className="numpad__button"
                onClick={onClick}
                disabled={value.length === 0}
                data-backspace
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                    <path d="M 9 7 C 4.042969 7 0 11.042969 0 16 L 0 34 C 0 38.957031 4.042969 43 9 43 L 41 43 C 45.957031 43 50 38.957031 50 34 L 50 16 C 50 11.042969 45.957031 7 41 7 Z M 9 9 L 41 9 C 44.878906 9 48 12.121094 48 16 L 48 34 C 48 37.878906 44.878906 41 41 41 L 9 41 C 5.121094 41 2 37.878906 2 34 L 2 16 C 2 12.121094 5.121094 9 9 9 Z M 20.375 15.5 C 20.152344 15.523438 19.941406 15.625 19.78125 15.78125 L 11.28125 24.28125 C 11.085938 24.46875 10.976563 24.730469 10.976563 25 C 10.976563 25.269531 11.085938 25.53125 11.28125 25.71875 L 19.78125 34.21875 C 20.179688 34.617188 20.820313 34.617188 21.21875 34.21875 C 21.617188 33.820313 21.617188 33.179688 21.21875 32.78125 L 14.4375 26 L 40 26 C 40.359375 26.003906 40.695313 25.816406 40.878906 25.503906 C 41.058594 25.191406 41.058594 24.808594 40.878906 24.496094 C 40.695313 24.183594 40.359375 23.996094 40 24 L 14.4375 24 L 21.21875 17.21875 C 21.542969 16.917969 21.628906 16.441406 21.433594 16.046875 C 21.242188 15.648438 20.808594 15.429688 20.375 15.5 Z" />
                </svg>
            </button>
        </div>
    );
};

Numpad.propTypes = {
    value: PropTypes.arrayOf(PropTypes.number).isRequired,
    setValue: PropTypes.func.isRequired,
};

export default Numpad;
